
import { Skeleton, SkeletonItem } from "element-ui"
import ware from "../dshop/ware-view/ware"
import { trackViewItemList } from "@/utils/track"
import ObserverHOC from "@/components/ObserverHOC"

// import { ware } from 'ui-library-web';

// 将数组数据分行
function arrayToRow(arr, row) {
  if (!arr) return []
  const result = []
  let output = []
  for (let i = 0; i < arr.length; i++) {
    arr[i].index = i % row
    if (i % row === 0 && i !== 0) {
      result.push([...output])
      output = [arr[i]]
    } else {
      output.push(arr[i])
    }
  }
  result.push([...output])
  return result
}

export default {
  name: "WareViewList",
  components: {
    [Skeleton.name]: Skeleton,
    [SkeletonItem.name]: SkeletonItem,
    ware,
    ObserverHOC
  },
  props: {
    rowNum: {
      type: Number,
      default: 5
    },
    wareList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    categoryArr: {
      type: Array,
      default: () => []
    },
    itemListName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      cartList: []
    }
  },

  computed: {},
  watch: {
    wareList: {
      handler(newVal) {
        if (!newVal) return
        const addCategory = newVal.map(v => {
          v.categoryArr = this.categoryArr
          return v
        })
        this.list = arrayToRow(addCategory, this.rowNum)
      },
      immediate: true
    }
  },

  mounted() {
    this.$bus.$on("getCartSkuList", this.handleCartList)
  },
  beforeDestroy() {
    this.$bus.$off("getCartSkuList", this.handleCartList)
  },
  methods: {
    handleCartList(val) {
      this.cartList = val
    },
    handleVisibility(target, index) {
      trackViewItemList(this.list[index], this.itemListName, this.itemListName)
    }
  }
}
